import React from 'react';
import './StartTest.scss';

const StartTest = () => {

    return (
        <div className='test-main'>
            <div className='note-main'>
                <h2>Please note</h2>
                <p>If you need to restart the test press the close button in the top right of screen</p>
            </div>
        </div>
    )
}

export default StartTest